import React from 'react';
import { Navigate } from 'react-router-dom';
import { useDealsAccess } from '../hooks/useDealsAccess';
import { useActiveWorld } from '../hooks/useActiveWorld';
import { CreditGateProvider } from '../hooks/useCreditGate';

/**
 * Route-Guard für /deals und /value-offer.
 *
 * Bewusst NICHT ProtectedRoute: das prüft `isPremium` auf dem eigenen
 * Users-Datensatz und würde Team-Member auf /unlock werfen, obwohl die
 * Lizenz beim World-Owner liegt. Gleiche Logik wie beim `hasWorldAccess`-
 * Gate der /world- und /leads-Routen in App.js.
 */
const DealsRoute = ({ children }) => {
  const { isLoading, hasAccess } = useDealsAccess();
  const { userId } = useActiveWorld();

  if (isLoading) {
    return (
      <>
        <style>{`
          @keyframes deals-gate-gradient { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
          @keyframes deals-gate-rotate { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
          @keyframes deals-gate-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.6; } }
        `}</style>
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          width: '100%', height: '100vh',
          background: 'linear-gradient(45deg, #ffffff, #f8fbff, #e8f4fd, #ffffff)',
          backgroundSize: '400% 400%', animation: 'deals-gate-gradient 1s ease infinite'
        }}>
          <div style={{ width: '100px', height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px', animation: 'deals-gate-rotate 2s linear infinite' }}>
            <img src="/img/salesgod_dark.webp" alt="SalesGod" style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'contain' }} />
          </div>
          <div style={{ fontSize: '18px', fontWeight: '600', color: '#3182ce', fontFamily: 'Inter, sans-serif', animation: 'deals-gate-pulse 1s ease-in-out infinite' }}>Loading...</div>
        </div>
      </>
    );
  }

  if (!hasAccess) return <Navigate to="/" replace />;

  // These routes live OUTSIDE WorldLayout, so without their own provider the
  // offer page would be the one place where an empty balance stays invisible —
  // and company research fires automatically on mount, so the user would just
  // see it fail.
  return <CreditGateProvider userId={userId}>{children}</CreditGateProvider>;
};

export default DealsRoute;
